import { Box, styled } from "@mui/material";

export const BoxButton = styled(Box)(({theme}) => ({
    marginLeft: "1rem",
    [theme.breakpoints.down("md")]: {
        marginLeft: "0rem",
    }
}));